<template>
<div id="datos_contribuyente">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12">
        <base-material-card color="primary" icon="library_books" title="Información de Empresa" class="elevation-1 px-5 py-3">
        <v-flex x12 s6 m6 l6 style="text-align:right" v-if="!es_agente && sa31">
                        
                        <v-btn :disabled="model.id_datos_clientes <= 0" to="/clientes/vinculados" text color="secondary" >
                            <v-icon>launch</v-icon>Ver Domicilios Vinculados
                        </v-btn>
                    </v-flex>
          
            <v-flex x12 s6 m6 l6 style="text-align:right" v-if="!es_agente && sa24">
                        
                        <v-btn :disabled="model.id_datos_clientes <= 0" to="/sa24/domicilios" text color="secondary" >
                            <v-icon>launch</v-icon>Ver Domicilios Vinculados
                        </v-btn>
                    </v-flex>
          <v-card-text>
            <v-row>
              <v-col sm="12" md="6">
                <v-card class="mx-auto">
                 
                  <v-list two-line>
                    <v-list-item-group>
                      <v-simple-table v-if="cliente != null && cliente != undefined && Object.keys(cliente).length !== 0">
                        <tbody>
                          <tr v-for="x in campos">
                            <td style="font-weight:bold">{{x.text}}</td>
                            <td v-if="x.text == 'Régimen de Operación de la Empresa'">{{getRegimen(cliente[x.field][x.subfield])}}</td>
                            <td v-else-if="x.text == 'Tipo Programa'">{{getTipoPrograma(cliente[x.field][x.subfield])}}</td>
                            <td v-else>{{x.subfield != null ? cliente[x.field][x.subfield] : cliente[x.field]}}</td>
                          </tr>
                          <tr>
                            <td style="font-weight:bold">Configuracíon de Número de Pedimento</td>
                            <td>Aduana: {{cliente.cliente.posicion_aduana}} &nbsp;&nbsp;&nbsp;Patente: {{cliente.cliente.posicion_patente}} &nbsp;&nbsp;&nbsp;Pedimento: {{cliente.cliente.posicion_pedimento}}</td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-list-item-group>
                  </v-list>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small color="secondary" @click="abrir_modal_cliente" v-if="!es_agente">
                      <v-icon>mdi-pencil</v-icon>Editar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col sm="12" md="6">
                <v-card class="mx-auto">
                  <v-card-title>
                    <b>Adjuntos</b>
                    <v-spacer></v-spacer>
                    <v-btn fab x-small color="secondary" @click="abrir_modal_adjuntos" v-if="!es_agente" title="Agregar Adjunto">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-card-title>
                  <hr>
                  <div id="datagrid">

                    <v-client-table ref="vuetable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2">
                      <template slot="noResults">
                        <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                      </template>

                      <template slot="actions" slot-scope="props">
                        <v-btn x-small fab dark color="green" @click.native="descargar_adjunto(props.row.adjunto)" title="Descargar Adjunto" v-tippy v-if="es_agente">
                            <v-icon>mdi-download</v-icon>
                          </v-btn>
                        <v-speed-dial :id="props.row.id" direction="right" open-on-hover v-if="!es_agente">
                          <template v-slot:activator>
                            <v-btn :id="props.row.id" x-small fab dark color="primary">
                              <v-icon>reorder</v-icon>
                            </v-btn>
                          </template>
                          <v-btn x-small fab dark color="green" @click.native="descargar_adjunto(props.row.adjunto)" title="Descargar Adjunto" v-tippy>
                            <v-icon>mdi-download</v-icon>
                          </v-btn>
                        
                          <v-btn x-small fab dark color="blue" @click.native="abrir_modal_update(props.row.id, props.row.nombre, props.row.orden)" title="Editar Adjunto" v-tippy>
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <v-btn x-small fab dark color="pink" @click.native="deleteAdjunto(props.row.id)" title="Eliminar Adjunto" v-tippy>
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-speed-dial>
                      </template>
                    </v-client-table>
                  </div>
                  
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="12" md="12">
              <v-card  v-if="es_agente "
                        class="elevation-1 px-5 py-3">
                        <v-card-title>
                          <strong>Domicilios Registrados</strong>
                        </v-card-title>
                        <v-card-text>
                            <v-card-text>
                                <v-client-table ref="vuetable" :data="datos" :columns="Dcolumns" :options="Doptions"
                                    class="elevation-2 pa-2">
                                    <template slot="noResults">
                                        <v-alert :value="true" icon="info" color="info">No se encontró ningún
                                            registro</v-alert>
                                    </template>

                                   
                                </v-client-table>
                            </v-card-text>
                        </v-card-text>
                    </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="12" md="12">
              <v-card 
                        class="elevation-1 px-5 py-3">
                        <v-card-title>
                          <strong>Licencia de Servicio de Software</strong>
                          <v-spacer></v-spacer>
                          <v-btn fab x-small color="secondary" @click="openModalLicencia(1)" v-if="!es_agente" title="Agregar Licencia">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </v-card-title>
                        <v-card-text>
                            <v-card-text>
                                <v-client-table ref="vuetable_licencias" :data="datos_licencias" :columns="columns_licencias" :options="options_licencias"
                                    class="elevation-2 pa-2">
                                    <template slot="noResults">
                                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                    </template>

                                    <template slot="actions" slot-scope="props">                                      
                                        <v-btn x-small fab dark v-if="!es_agente" color="info" @click.native="show_adjuntos_licencia(props.row.id, props.row.descripcion)" title="Adjuntar Documento" v-tippy>
                                          <v-icon>mdi-upload</v-icon>
                                        </v-btn>&nbsp;
                                        <v-btn x-small fab dark v-if="!es_agente" color="blue" @click.native="get_licencia(props.row.id)" title="Editar Licencia" v-tippy>
                                          <v-icon>edit</v-icon>
                                        </v-btn>&nbsp;
                                        <v-btn x-small fab dark v-if="!es_agente" color="pink" @click.native="delete_licencia(props.row.id)" title="Eliminar Licencia" v-tippy>
                                          <v-icon>delete</v-icon>
                                        </v-btn>
                                      </v-speed-dial>
                                    </template>
                                   
                                </v-client-table>
                            </v-card-text>
                        </v-card-text>
                    </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  
  </v-container>

  <v-dialog v-model="modal" max-width="40%" style=" z-index: 400 !important;">
    <v-card>
      <v-card-title>
        <v-card class="primary white--text titulomodal">
          <v-icon class="white--text" @click.native="modal = false">cancel</v-icon>&nbsp;
          <span class="subheading">
            <strong>Editar Datos</strong>
          </span>
        </v-card>

      </v-card-title>
      <v-form ref="form" lazy-validation>
        <v-card-text>
          <br>
          <v-container fluid grid-list-md text-xs-center @keyup.enter="guardar()">
            <v-row row wrap>
              <v-col sm="12">
                <v-autocomplete v-model="model.id_a31_regimen" :items="regimenes" item-text="text" item-value="id" label="Régimen de Operación de la Empresa" />
              </v-col>
              <v-col cols="12" sm="12">
                <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                  <template v-slot:activator="{ on }">
                    <v-text-field v-on="on" v-model="model.fecha_aprobacion" label="Fecha de Aprobación" color="secondary" prepend-icon="event" @blur="model.fecha_aprobacion = parseDate(model.fecha_aprobacion)" v-mask="'####-##-##'"
                      :rules="[]"></v-text-field>
                  </template>

                  <v-date-picker v-model="model.fecha_aprobacion" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                    <v-spacer />

                    <v-btn color="secondary" x-small @click="menu1 = false">
                      Cancelar
                    </v-btn>
                  </v-date-picker>
                </v-menu>

              </v-col>
              <v-col cols="12" sm="12">
                <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                  <template v-slot:activator="{ on }">
                    <v-text-field v-on="on" v-model="model.fecha_termino" label="Fecha de Término" color="secondary" prepend-icon="event" @blur="model.fecha_termino = parseDate(model.fecha_termino)" v-mask="'####-##-##'"
                      :rules="[]"></v-text-field>
                  </template>

                  <v-date-picker v-model="model.fecha_termino" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                    <v-spacer />

                    <v-btn color="secondary" x-small @click="menu2 = false">
                      Cancelar
                    </v-btn>
                  </v-date-picker>
                </v-menu>

              </v-col>
              <v-col sm="12">
                <v-autocomplete v-model="model.id_certificacion" :items="tipo_certificaciones" item-text="text" item-value="id" label="Tipo Programa" />
              </v-col>
              <v-col sm="12">
                <v-text-field label="Folio" v-model="model.folio"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="12">
                <v-label>Configuración de Número de Pedimento</v-label>
              </v-col>
              <v-col md="4" sm="4" lg="4">
                <v-text-field label="Posición Aduana" :rules="[validaPosicionAduana]" v-model="model.posicion_aduana" @keyup="soloNumeros('posicion_aduana')" maxlength="3"></v-text-field>
              </v-col>
              <v-col md="4" sm="4" lg="4">
                <v-text-field label="Posición Patente" :rules="[validaPosicionPatente]" v-model="model.posicion_patente" @keyup="soloNumeros('posicion_patente')" maxlength="3"></v-text-field>
              </v-col>
                <v-col md="4" sm="4" lg="4">
                <v-text-field label="Posición Pedimento" :rules="[validaPosicionPedimento]" v-model="model.posicion_pedimento" @keyup="soloNumeros('posicion_pedimento')" maxlength="3"></v-text-field>                
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click.native="modal = false; cargarDatosCliente();">
          <v-icon>cancel</v-icon> Cancelar
        </v-btn> &nbsp;        
        <v-btn small color="success" :loading="loading" @click.native="guardar()">
          <v-icon>done</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="modal_adjuntos" max-width="30%" style=" z-index: 400 !important;">
    <v-card>
      <v-card-title>
        <v-card class="primary white--text titulomodal">
          <v-icon class="white--text" @click.native="modal_adjuntos = false">cancel</v-icon>&nbsp;
          <span class="subheading">
            <strong>Adjuntar Documento</strong>
          </span>
        </v-card>

      </v-card-title>
      <v-form ref="form_adjuntos" lazy-validation>
        <v-card-text>
          <br>
          <v-container fluid grid-list-md text-xs-center @keyup.enter="guardar_adjunto">
            <v-row row wrap>
              <v-col sm="12">
                <v-text-field label="Orden" v-model="model_adjuntos.orden" :rules="[rules.required]" v-mask="'##'"></v-text-field>
              </v-col>
              <v-col sm="12">
                <v-text-field label="Nombre" v-model="model_adjuntos.nombre_nuevo" :rules="[rules.required]"></v-text-field>
              </v-col>
              <v-col class="d-flex" cols="12" sm="12">
                <v-text-field label="Selecciona el archivo" @click='pickFile' v-model='model_adjuntos.nombre' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                <input type="file" style="display: none" ref="file_input" accept=".pdf" @change="onFilePicked">
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click.native="modal_adjuntos = false;">
          <v-icon>cancel</v-icon> Cancelar
        </v-btn>        
        <v-btn small color="success" :loading="loading" @click.native="guardar_adjunto">
          <v-icon>done</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="modal_update" max-width="30%" style=" z-index: 400 !important;">
    <v-card>
      <v-card-title>
        <v-card class="primary white--text titulomodal">
          <v-icon class="white--text" @click.native="modal_update = false">cancel</v-icon>&nbsp;
          <span class="subheading">
            <strong>Cambiar Nombre</strong>
          </span>
        </v-card>

      </v-card-title>
      <v-form ref="form_adjuntos" lazy-validation>
        <v-card-text>
          <br>
          <v-container fluid grid-list-md text-xs-center @keyup.enter="update_adjunto">
            <v-row row wrap>
              <v-col sm="12">
                <v-text-field label="Orden" v-model="model_update.orden" :rules="[rules.required]" v-mask="'##'"></v-text-field>
              </v-col>
              <v-col sm="12">
                <v-text-field label="Nombre" v-model="model_update.nombre" :rules="[rules.required]"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click.native="modal_update = false;">
          <v-icon>cancel</v-icon> Cancelar
        </v-btn> &nbsp;
        <v-btn small color="success" :loading="loading" @click.native="update_adjunto">
          <v-icon>done</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="modal_licencia" max-width="35%" style=" z-index: 400 !important;">
    <v-card>
      <v-card-title>
        <v-card class="primary white--text titulomodal">
          <v-icon class="white--text" @click.native="modal_licencia = false">cancel</v-icon>&nbsp;
          <span class="subheading">
            <strong>{{update==true?'Actualizar':'Agregar'}} Licencia</strong>
          </span>
        </v-card>

      </v-card-title>
      <v-form ref="form_licencia" lazy-validation>
        <v-card-text>
          <br>
          <v-container fluid grid-list-md text-xs-center @keyup.enter="guarda_licencia()">
            <v-row row wrap>
              <v-col sm="12">
                <v-text-field label="Descripción" v-model="model_licencia.descripcion" :rules="[rules.required]"></v-text-field>
              </v-col>
              <v-col sm="12">
                <v-text-field label="Especificación" v-model="model_licencia.especificacion" :rules="[rules.required]"></v-text-field>
              </v-col>
              <v-col sm="6">
                <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                  <template v-slot:activator="{ on }">
                    <v-text-field v-on="on" v-model="model_licencia.fecha" label="Fecha" color="secondary" prepend-icon="event" @blur="model_licencia.fecha = parseDate(model_licencia.fecha)" v-mask="'####-##-##'"
                      :rules="[rules.required]"></v-text-field>
                  </template>

                  <v-date-picker v-model="model_licencia.fecha" color="secondary" scrollable locale="es-mx" @input="menu3 = false">
                    <v-spacer />

                    <v-btn color="secondary" x-small @click="menu3 = false">
                      Cancelar
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col sm="12">
                <v-text-field label="Número" v-model="model_licencia.numero" :rules="[rules.required]"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click.native="modal_licencia = false;">
          <v-icon>cancel</v-icon> Cancelar
        </v-btn> &nbsp;        
        <v-btn small color="success" :loading="loading" @click.native="guarda_licencia()">
          <v-icon>done</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="modal_adjuntos_licencia" max-width="60%" style=" z-index: 400 !important;">
    <v-card>
      <v-card-title>
        <v-card class="primary white--text titulomodal">
          <v-icon class="white--text" @click.native="modal_adjuntos_licencia = false">cancel</v-icon>&nbsp;
          <span class="subheading">
            <strong>Documentos Adjuntos a Licencia: {{descripcion_licencia}}</strong>
          </span>
        </v-card>

      </v-card-title>
      <v-form ref="form_adjuntos" lazy-validation>
        <v-card-text>
          <br>
          <v-container fluid grid-list-md text-xs-center @keyup.enter="guardar_adjunto">
            <v-row row wrap>
              <v-col sm="4">
                <v-text-field label="Orden" v-model="model_adjuntos.orden" :rules="[rules.required]" v-mask="'##'"></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field label="Nombre" v-model="model_adjuntos.nombre_nuevo" :rules="[rules.required]"></v-text-field>
              </v-col>
              <v-col class="d-flex" cols="4" sm="4">
                <v-text-field label="Selecciona el archivo" @click='pickFile' v-model='model_adjuntos.nombre' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                <input type="file" style="display: none" ref="file_input" accept=".pdf, image/*" @change="onFilePicked">
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small color="success" :loading="loading" @click.native="guardar_adjunto">
          <v-icon>done</v-icon>
          Guardar
        </v-btn>
      </v-card-actions>
      <v-card-text>
        <v-client-table ref="vuetable" :data="adjuntos_licencia" :columns="columns" :options="options" class="elevation-2 pa-2">
                      <template slot="noResults">
                        <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                      </template>

                      <template slot="actions" slot-scope="props">
                        <v-btn x-small fab dark color="green" @click.native="descargar_adjunto(props.row.adjunto)" title="Descargar Adjunto" v-tippy v-if="es_agente">
                            <v-icon>mdi-download</v-icon>
                          </v-btn>
                        <v-speed-dial :id="props.row.id" direction="right" open-on-hover v-if="!es_agente">
                          <template v-slot:activator>
                            <v-btn :id="props.row.id" x-small fab dark color="primary">
                              <v-icon>reorder</v-icon>
                            </v-btn>
                          </template>
                          <v-btn x-small fab dark color="green" @click.native="descargar_adjunto(props.row.adjunto)" title="Descargar Adjunto" v-tippy>
                            <v-icon>mdi-download</v-icon>
                          </v-btn>                        
                          <v-btn x-small fab dark color="pink" @click.native="deleteAdjunto(props.row.id)" title="Eliminar Adjunto" v-tippy>
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-speed-dial>
                      </template>
                    </v-client-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small @click.native="modal_adjuntos_licencia = false;">
          <v-icon>cancel</v-icon>&nbsp;Cerrar
        </v-btn>        
      </v-card-actions>
    </v-card>
  </v-dialog>
 
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  components: {},
  data: vm => ({
    descripcion_licencia:"",
    adjuntos_licencia:[],
    modal_adjuntos_licencia:false,
    update:false,
    model_licencia:{      
      rfc:"",
      descripcion:"",
      especificacion:"",
      fecha:"",
      numero:"",
      user_updated:""
    },
    modal_licencia:false,
    datos_licencias:[],
    columns_licencias: ["descripcion","especificacion","fecha","numero","actions"],
    options_licencias:{
      filterable: [],
      sortable: [],
      headings: {
        descripcion: "Descripción",
        especificacion: "Especificación",
        numero: "Número",
        actions: "Opciones"
      }
    },
    datos: [],
            Dcolumns: [
                "calle",
                "numero",
                "codigo_postal",
                "colonia",
                "ciudad",
                "entidad_federativa",
                "tipo_domicilio",
                "observaciones"
            ],
            Doptions: {
                filterable: [
                ],
                sortable: [
                    "ciudad"
                ],

                headings: {
                    numero: "Número",
                    codigo_postal: "Código Postal",
                    entidad_federativa: "Entidad Federativa",
                    tipo_domicilio: "Tipo Domicilio",
                }
            },
    items: [],
    campos: [{
        "text": "Razón Social",
        "field": 'cliente',
        "subfield": "nombre"
      },
      {
        "text": "RFC",
        "field": 'cliente',
        "subfield": "identificador"
      },
     /*  {
        "text": "Domicilio",
        "field": 'domicilio',
        "subfield": null
      },
      {
        "text": "Colonia",
        "field": 'colonia',
        "subfield": null
      },
      {
        "text": "Ciudad",
        "field": 'ciudad',
        "subfield": null
      },
      {
        "text": "Estado",
        "field": 'estado',
        "subfield": 'nombre'
      },
      {
        "text": "País",
        "field": 'pais',
        "subfield": 'nombre'
      },
      {
        "text": "CP",
        "field": 'codigo_postal',
        "subfield": null
      }, */
      {
        "text": "Régimen de Operación de la Empresa",
        "field": 'cliente',
        "subfield": 'id_a31_regimen'
      },
      {
        "text": "Fecha de Aprobación",
        "field": 'cliente',
        "subfield": 'fecha_aprobacion'
      },
      {
        "text": "Fecha de Término",
        "field": 'cliente',
        "subfield": 'fecha_termino'
      },
      {
        "text": "Tipo Programa",
        "field": 'cliente',
        "subfield": 'id_certificacion'
      },
      {
        "text": "Número de Registro",
        "field": 'cliente',
        "subfield": 'folio'
      },
    ],
    columns: [
      'actions',
      'nombre'
    ],
    options: {
      columnsClasses: {
        'nombre': 'ancho'
      },
      filterable: [],
      sorteable: [],
      headings: {
        "nombre": "Adjunto",
        "actions": ""
      },
    },
    name: "datagrid",
    menu1: false,
    menu2: false,
    menu3: false,
    regimenes: [],
    tipo_certificaciones: [],
    show_loading: true,
    URL: "",
    show_loading: true,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Tipo de Programa",
        disabled: true,
        to: ""
      }
    ],
    loading: false,
    title: "",
    modal: false,
    modal_adjuntos: false,
    update: false,
    model: {},
    model_adjuntos: {},
    rules: {
      required: v => !!v || "Este campo es requerido"
    },
    cliente: {},
    modal_adjuntos: false,
    model_update: {},
    modal_update: false
  }),
  computed: {
        es_agente(){
            return this.$local_storage.get("perfil_grupo") == 66;
        },
        sa31() {
            return this.$store.state.sa31 == 1
             
        },
        sa24() {
            return this.$store.state.sa24 == 1
        },
      },
  methods: {
    validaPosicionAduana: function(val){
      const pattern = /^[\d]*$/;
      
      if(this.model.posicion_aduana && pattern.test(this.model.posicion_aduana) && this.model.posicion_patente && pattern.test(this.model.posicion_patente) ){
        if(this.model.posicion_aduana == this.model.posicion_patente){
          return "Posición repetida";
        }        
      }
      
      if(this.model.posicion_aduana && pattern.test(this.model.posicion_aduana) && this.model.posicion_pedimento && pattern.test(this.model.posicion_pedimento) ){
        if(this.model.posicion_aduana == this.model.posicion_pedimento){
          return "Posición repetida";
        }        
      }

      return true;
    },
    validaPosicionPatente: function(val){
      const pattern = /^[\d]*$/;
      
      if(this.model.posicion_aduana && pattern.test(this.model.posicion_aduana) && this.model.posicion_patente && pattern.test(this.model.posicion_patente) ){
        if(this.model.posicion_aduana == this.model.posicion_patente){
          return "Posición repetida";
        }        
      }
      
      if(this.model.posicion_patente && pattern.test(this.model.posicion_patente) && this.model.posicion_pedimento && pattern.test(this.model.posicion_pedimento) ){
        if(this.model.posicion_patente == this.model.posicion_pedimento){
          return "Posición repetida";
        }        
      }

      return true;
    },
    validaPosicionPedimento: function(val){
      const pattern = /^[\d]*$/;
      
      if(this.model.posicion_aduana && pattern.test(this.model.posicion_aduana) && this.model.posicion_pedimento && pattern.test(this.model.posicion_pedimento) ){
        if(this.model.posicion_aduana == this.model.posicion_pedimento){
          return "Posición repetida";
        }        
      }

      if(this.model.posicion_patente && pattern.test(this.model.posicion_patente) && this.model.posicion_pedimento && pattern.test(this.model.posicion_pedimento) ){
        if(this.model.posicion_patente == this.model.posicion_pedimento){
          return "Posición repetida";
        }        
      }

      return true;
    },
    soloNumeros: function(campo){ 
          const pattern = /^[\d]*$/;
          let value = this.model[campo];
          if (!pattern.test(value) ){
              this.model[campo] = this.model[campo].substring(0,this.model[campo].length-1);
              this.soloNumeros(campo);
              //console.log("INVALIDO")
          } 
          //else 
              //console.log("VALIDO");             
      },
    cargar: function () {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            let data = {
                rfc: this.rfc,
            };
            axios
                .post(this.$apiSA31 + "soluciona24/get_domicilios/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos = res.data
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener la bitácora.",
                        footer: ""
                    });
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
    clean_model: function() {
      return {
        id: this.$local_storage.get("id_cliente"),
        id_certificacion: null,
        fecha_aprobacion: null,
        fecha_termino: null,
        folio: null,
        id_a31_regimen: null,
        posicion_aduana: null,
        posicion_patente: null,
        posicion_pedimento: null,
      }
    },
    parseDate(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    guardar() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        if(this.model.posicion_aduana==''){
          this.model.posicion_aduana = null;
        }
        if(this.model.posicion_patente==''){
          this.model.posicion_patente = null;
        }
        if(this.model.posicion_pedimento==''){
          this.model.posicion_pedimento = null;          
        }
        var metodo = "post";
        var urlCliente = this.URL + "guardar_datos_cliente_soluciona/";        
        axios({
            method: metodo,
            url: urlCliente,
            data: this.model
          })
          .then(res => {
            this.$swal({
              type: "success",
              title: "¡Operación Exitosa!",
              text: "Los datos se guardaron correctamente",
              footer: ""
            });
          })
          .catch(error => {
            this.$swal({
              position: "center",
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al guardar los datos"
              //showConfirmButton: false,
            });
            console.log(error);
          })
          .then(() => {
            this.cargarDatosCliente();
            this.$root.$dialogLoader.hide();
            this.modal = false;
          });
      }
    },
    cargarDatosCliente: function() {
      axios
        .post(this.URL + "get_info_cliente/", {        
          "id": this.$local_storage.get("id_cliente")
        })
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.cliente = res.data;            
            this.$root.$dialogLoader.hide();
          }
        })
        .catch(err => {

          console.log(err);
          this.$root.$dialogLoader.hide();
        });
    },
    cargarAdjuntos: function() {
      axios
        .post(this.URL + "get_adjuntos_cliente/", {
          "id": this.$local_storage.get("id_cliente")
        })
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.items = res.data;
            this.$root.$dialogLoader.hide();
          }
        })
        .catch(err => {

          console.log(err);
          this.$root.$dialogLoader.hide();
        });
    },
    
    getRegimenes: function() {
      this.regimenes = [];
      axios
        .post(this.$hostname + "apendices/lista/", {
          "tabla": 34
        })
        .then(res => {
          if (typeof res.data !== "undefined") {
            for (var i = 0; i < res.data.length; i++) {
              if (res.data[i].nombre == "TODOS") {
                continue;
              }
              this.regimenes.push({
                "id": res.data[i].id,
                "text": res.data[i].nombre
              });
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los régimenes.",
            footer: ""
          });
          console.log(err);
        });
    },
    getTiposCertificaciones: function() {
      this.tipo_certificaciones = [];
      axios
        .get(this.$hostname + "catalogos/certificaciones/")
        .then(res => {
          if (typeof res.data !== "undefined") {
            for (var i = 0; i < res.data.length; i++) {
              this.tipo_certificaciones.push({
                "id": res.data[i].id,
                "text": res.data[i].nombre
              });
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los tipos de certificacion.",
            footer: ""
          });
          console.log(err);
        });
    },
    abrir_modal_update: function(id_registro, nombre, orden) {
      this.model_update = {
        "id": id_registro,
        "nombre": nombre,
        "orden": orden
      };

      this.modal_update = true;
    }, //getRegistro
    deleteAdjunto: function(id_registro) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el registro?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          axios.post(this.URL + "borrar_adjunto_cliente/", {
            "id": id_registro
          }).then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El registro se eliminó correctamente.",
              //position: 'bottom-end',
              //timer: 3000,
              //showConfirmButton: false,
              footer: ""
            });
          }).catch(error => {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al eliminar el registro",
              footer: ""
            });
          }).then(() => {
            this.$root.$dialogLoader.hide();
            this.cargarAdjuntos();
            if(this.model_adjuntos["id_licencia"]){
              this.show_adjuntos_licencia(this.model_adjuntos["id_licencia"], this.descripcion_licencia);
            }
          });
        }
      });
    }, //delete
    getRegimen: function(id) {
      for (var i = 0; i < this.regimenes.length; i++) {
        if (this.regimenes[i].id == id) {
          return this.regimenes[i].text;
        }
      }

      return "N/A";
    },
    getTipoPrograma: function(id) {
      for (var i = 0; i < this.tipo_certificaciones.length; i++) {
        if (this.tipo_certificaciones[i].id == id) {
          return this.tipo_certificaciones[i].text;
        }
      }

      return "N/A";
    },
    abrir_modal_cliente: function() {
      this.model = this.clean_model();

      try {
        if(this.cliente.cliente){
          this.model.id_a31_regimen = this.cliente.cliente.id_a31_regimen;
          this.model.fecha_aprobacion = this.cliente.cliente.fecha_aprobacion;
          this.model.fecha_termino = this.cliente.cliente.fecha_termino;
          this.model.folio = this.cliente.cliente.folio;
          this.model.id_certificacion = this.cliente.cliente.id_certificacion;
          this.model.posicion_aduana = this.cliente.cliente.posicion_aduana;
          this.model.posicion_patente = this.cliente.cliente.posicion_patente;
          this.model.posicion_pedimento = this.cliente.cliente.posicion_pedimento;
        } 
      } catch (error) {
        console.log(error);
      }            

      this.modal = true
    },
    abrir_modal_adjuntos: function() {
      this.model_adjuntos = {
        "id": this.$local_storage.get("id_cliente"),
        "archivo": null,
        "nombre": null,
        "type": null,
        "nombre_nuevo": null,
        "orden": null
      };

      this.modal_adjuntos = true;
    },
    pickFile() {
      this.$refs.file_input.click()
    },
    onFilePicked(e) {
      try {
        const files = e.target.files;

        if (files[0] !== undefined) {

          this.model_adjuntos.nombre = files[0].name;
          this.model_adjuntos.type = files[0].type;
          this.model_adjuntos.archivo = files[0]

        }
      } catch (error) {
        console.log(error);
        this.$swal({
          type: "error",
          title: "¡Operación no Permitida!",
          text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
          footer: ""
        });        
      }
    },
    
    descargar_adjunto: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    guardar_adjunto: function() {
      if (!this.$refs.form_adjuntos.validate()) {
        return;
      }
      this.modal_adjuntos = false;
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var self = this;
      var keyFile = this.$local_storage.get("rfc") + "/soluciona31/adjuntos/" + Date.now() + "_" + this.model_adjuntos.nombre;

      var datos = {
        key: keyFile,
        bucket: "production.econnect.ds",
        type: this.model_adjuntos.type
      }

      axios.post(this.$hostname + 's3/upload_url/', datos).then((res) => {
          if (typeof res.data !== 'undefined') {
            var urlput = res.data.mensaje;
            axios.put(urlput, this.model_adjuntos.archivo, {
                headers: {
                  'Content-Type': this.model_adjuntos.type
                }
              })
              .then((res) => {
                self.guardar_key(keyFile);
              })
              .catch((error) => {
                this.$root.$dialogLoader.hide();
                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                  footer: '',
                });
                console.log(error);
              });

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
          this.$root.$dialogLoader.hide();
        });
    },
    guardar_key: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
          "id_cliente": this.model_adjuntos.id,
          "adjunto": key,
          "nombre": this.model_adjuntos.nombre_nuevo,
          "orden": this.model_adjuntos.orden
        };
      if(this.model_adjuntos["id_licencia"]){//Si es para licencia, se agregan a los datos del post
        datos["licencia_id"] = this.model_adjuntos["id_licencia"];
        datos["tipo"] = 3;
      } 
      axios
        .post(this.URL + "guardar_adjunto_cliente/", datos)
        .then(res => {
          this.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: "El archivo se cargo correctamente",
            footer: ""
          });
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al subir el archivo",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
          this.cargarAdjuntos();
          if(this.model_adjuntos["id_licencia"]){
            this.show_adjuntos_licencia(this.model_adjuntos["id_licencia"], this.descripcion_licencia);
          }
        });
    },
    update_adjunto: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      axios
        .post(this.URL + "update_adjunto_cliente/", this.model_update)
        .then(res => {
          this.$swal({
            type: "success",
            title: "¡Operación Exitosa!",
            text: "El registro se actualizó correctamente",
            footer: ""
          });
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al actualizar",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
          this.cargarAdjuntos();
          this.modal_update = false;
        });
    },
    openModalLicencia: function (type) {
          if (type === 1) {            
              this.model_licencia = {
                rfc: this.$local_storage.get("rfc"),
                descripcion:"",
                especificacion:"",
                fecha:"",
                numero:"",
                user_updated: this.$local_storage.get("email")
              };
              this.update = false;
          } else {
              this.update = true;
          }
          this.modal_licencia = true;
      },
    guarda_licencia: function(){
      if (!this.$refs.form_licencia.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
        const datos = JSON.parse(JSON.stringify(this.model_licencia));
        var metodo = "post";
        var urlCliente = this.$hostname+'catalogos/licencias/';             
        if (this.update == true) {
            metodo = "put";
            urlCliente += this.model_licencia.id + "/";
        }
        axios({
                method: metodo,
                url: urlCliente,
                data: datos
            })
            .then(res => {
                this.$swal({
                    type: "success",
                    title: "¡Operación Exitosa!",
                    text: "Los datos se guardaron correctamente",
                    footer: ""
                });                
                this.modal_licencia = false;
            })
            .catch(error => {
                this.$swal({
                    position: "center",
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al guardar los datos. Intente nuevamente por favor."
                    //showConfirmButton: false,
                });                
                
            }).then(()=>{              
              this.cargarLicencias(1);              
            });
      }
    },
    
    cargarLicencias: function (opcion=0) {
        var rfc = this.$local_storage.get("rfc");    
        axios.post(this.$hostname+'catalogos/licencias/get_licencias/',{"rfc":rfc})        
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.datos_licencias = res.data;   
                    this.datos_licencias.sort(function (a, b) {
                        //Ordenar por fecha más reciente
                        return new Date(b.fecha) - new Date(a.fecha);
                    });                                 
                }
            })
            .catch(err => {                
                console.log(err);                
            }).then(()=>{
              if(opcion == 1){
                this.$root.$dialogLoader.hide();
              }
            });
    },

    get_licencia: function (id_registro) {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        axios
            .get(this.$hostname+'catalogos/licencias/' + id_registro + "/")                     
            .then(response => {
                this.model_licencia = response.data;
                this.openModalLicencia(2);
            })
            .catch(error => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener el registro",
                    footer: ""
                });
            }).then(() => {
                this.$root.$dialogLoader.hide();
            });
    }, //getRegistro

    delete_licencia: function (id_registro) {
        this.$swal({
            type: "info",
            title: "Cuidado",
            text: "¿Está seguro de eliminar el registro?. Se eliminarán también los adjuntos de la licencia.",
            footer: "",
            showCancelButton: true,
            cancelButtonColor: "#d33",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                axios.delete(this.$hostname+'catalogos/licencias/' + id_registro + "/")                                      
                    .then(response => {

                      //Eliminamos los adjuntos de la licencia
                        axios.post(this.URL + "get_adjuntos_cliente/", {      
                          "id": this.$local_storage.get("id_cliente"),
                          "id_licencia": id_registro,
                          "tipo": 3, //3-Licencias de Software SA24
                        })
                        .then(res => {
                          if (typeof res.data !== "undefined") {
                            for(var k in res.data){
                              axios.post(this.URL + "borrar_adjunto_cliente/", {"id": res.data[k].id})
                                .then(response => {
                                  
                                }).catch(error => {
                                  console.log(error);
                                });
                            }
                          }
                        })
                        .catch(err => {
                          console.log(err);                          
                        });


                      this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente.",                            
                            footer: ""
                        });                                                
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro",
                            footer: ""
                        });
                    }).then(() => {
                        this.cargarLicencias(1);                        
                    });
            }
        });
    }, //delete
    show_adjuntos_licencia: function(id_licencia, descripcion) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      axios.post(this.URL + "get_adjuntos_cliente/", {      
          "id": this.$local_storage.get("id_cliente"),
          "id_licencia": id_licencia,
          "tipo": 3, //3-Licencias de Software SA24
        })
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.adjuntos_licencia = res.data;
            this.descripcion_licencia = descripcion;

            this.model_adjuntos = {
              "id": this.$local_storage.get("id_cliente"),
              "id_licencia":id_licencia, //Campo Exclusivo, para licencias
              "tipo": 3, //3-Adjuntos Licencia de Software SA24
              "archivo": null,
              "nombre": null,
              "type": null,
              "nombre_nuevo": null,
              "orden": null
            };

            this.modal_adjuntos_licencia = true;
            this.$root.$dialogLoader.hide();
          }
        })
        .catch(err => {
          console.log(err);
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los adjuntos. Intente nuevamente."            
          });
          this.$root.$dialogLoader.hide();
        });
    },
  }, //methods
  created: function() {
    this.URL = this.$hostname + "catalogos/clientes_certificaciones/";
    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');    
    this.getRegimenes();
    this.cargarLicencias();
    this.getTiposCertificaciones();
    this.cargarDatosCliente();
    this.cargarAdjuntos();    
  }
};
</script>
<style>
.ancho {
  width: 90% !important;
}
</style>
